const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export async function requestCorrection(chatId, messageId, csrf, { fetcher = fetch, signal,
  sleep = ms => new Promise(resolve => setTimeout(resolve, ms)) } = {}) {
  if (![chatId, messageId].every(id => UUID.test(id || '')) || !csrf) throw new Error('unavailable');
  const url = `/langua/cartus_chats/${chatId}/messages/${messageId}/correction`;
  let method = 'POST';
  for (let attempt = 0; attempt < 46; attempt++) {
    if (signal?.aborted) throw new Error('unavailable');
    const response = await fetcher(method === 'POST' ? '/langua/text_correction' : url, { method, credentials: 'same-origin', cache: 'no-store', redirect: 'error', signal,
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf }, ...(method === 'POST' ? { body: JSON.stringify({chat_id: chatId, chat_message_id: messageId}) } : {}) });
    if (!response.ok) throw new Error('unavailable');
    const result = await response.json();
    if (result.status === 'completed') {
      if (typeof result.correction !== 'string' || !result.correction.trim() || new TextEncoder().encode(result.correction).length > 8000) throw new Error('unavailable');
      return result.correction;
    }
    if (!['queued', 'running'].includes(result.status)) throw new Error('unavailable');
    method = 'GET';
    await sleep(1500);
  }
  throw new Error('unavailable');
}

// Build DOM nodes without interpreting model output as HTML, even for entities.
export function correctionFragment(text, page = document) {
  if (typeof text !== 'string' || /[\x00-\x08\x0b\x0c\x0e-\x1f]/.test(text)) throw new Error('unavailable');
  const root = page.createDocumentFragment(), stack = [root];
  for (const part of text.split(/(<\/?(?:b|del)>)/g)) {
    if (!part) continue;
    if (/^<(b|del)>$/.test(part)) {
      if (stack.length > 16) throw new Error('unavailable');
      const node = page.createElement(part.slice(1, -1)); stack[stack.length - 1].appendChild(node); stack.push(node);
    } else if (/^<\/(b|del)>$/.test(part)) {
      if (stack.length === 1 || stack.pop().tagName.toLowerCase() !== part.slice(2, -1)) throw new Error('unavailable');
    } else {
      if (/[<>]/.test(part)) throw new Error('unavailable');
      stack[stack.length - 1].appendChild(page.createTextNode(part));
    }
  }
  if (stack.length !== 1) throw new Error('unavailable');
  return root;
}
